import { render } from "./grades.vue?vue&type=template&id=7093eef8"
import script from "./grades.vue?vue&type=script&lang=js"
export * from "./grades.vue?vue&type=script&lang=js"

import exportComponent from "H:\\历届教学资料\\24-25课程\\self_study_room\\源代码\\client2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__